"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventAttendees = void 0;
var usePaginatedModel_1 = __importDefault(require("./usePaginatedModel"));
var useEventAttendees = function (experienceId, limit) {
    if (limit === void 0) { limit = 10; }
    var _a = (0, usePaginatedModel_1.default)("experiences/".concat(experienceId, "/attendees"), {
        limit: limit,
    }), data = _a.data, res = __rest(_a, ["data"]);
    return __assign({ attendees: data.results.map(function (a) { return a.user; }) }, res);
};
exports.useEventAttendees = useEventAttendees;
exports.default = exports.useEventAttendees;
//# sourceMappingURL=useEventAttendees.js.map